import * as z from "zod/v4";

const coerceUnitInterval = (value: unknown): unknown => {
  if (typeof value === "string") {
    const parsed = Number(value);
    if (!Number.isNaN(parsed)) return Math.min(1, Math.max(0, parsed));
  }
  if (typeof value === "number") return Math.min(1, Math.max(0, value));
  return value;
};

export const UnitIntervalSchema = z.number().min(0).max(1);

export const CoerceUnitIntervalSchema = z.preprocess(
  coerceUnitInterval,
  UnitIntervalSchema,
);
